"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var GeodesPreview22_exports = {};
__export(GeodesPreview22_exports, {
  default: () => GeodesPreview22_default
});
module.exports = __toCommonJS(GeodesPreview22_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M13.332 3.16016C13.332 3.02995 13.3776 2.91927 13.4688 2.82812C13.5729 2.72396 13.6966 2.67188 13.8398 2.67188H17.4922C17.6615 2.67188 17.7982 2.73047 17.9023 2.84766C18.0195 2.95182 18.0781 3.08854 18.0781 3.25781V6.91016C18.0781 7.05339 18.026 7.17708 17.9219 7.28125C17.8307 7.3724 17.7201 7.41797 17.5898 7.41797C17.4466 7.41797 17.3229 7.3724 17.2188 7.28125C17.1276 7.17708 17.082 7.05339 17.082 6.91016V4.37109L5.85156 15.6016C5.90365 15.7057 5.94271 15.8099 5.96875 15.9141C5.99479 16.0182 6.00781 16.1289 6.00781 16.2461C6.00781 16.6628 5.85807 17.0208 5.55859 17.3203C5.27214 17.6068 4.92057 17.75 4.50391 17.75C4.08724 17.75 3.72917 17.6068 3.42969 17.3203C3.14323 17.0208 3 16.6628 3 16.2461C3 15.8294 3.14323 15.4779 3.42969 15.1914C3.72917 14.8919 4.08724 14.7422 4.50391 14.7422C4.62109 14.7422 4.73177 14.7552 4.83594 14.7812C4.9401 14.8073 5.04427 14.8464 5.14844 14.8984L16.3789 3.66797H13.8398C13.6966 3.66797 13.5729 3.6224 13.4688 3.53125C13.3776 3.42708 13.332 3.30339 13.332 3.16016Z",
      fill: "currentColor"
    }
  )
);
const SvgGeodesPreview22 = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var GeodesPreview22_default = SvgGeodesPreview22;
